import {utilHelper} from "../../_helpers";

const relativeUrl = '/api/rolePermission'

export const rolePermissionService = {
    getList,
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    search,
    getPagedList,
    getAll,
};

function getPagedList(offset, max) {
    return utilHelper.doRequest(`${relativeUrl}?max=${max}&offset=${offset}`, 'GET')
}

function getAll() {
    return utilHelper.doRequest(`${relativeUrl}/getAll`, 'GET')
}

function getList() {
    return utilHelper.doRequest(`${relativeUrl}`, 'GET')
}

function search(offset, max, data) {
    return utilHelper.doRequest(`${relativeUrl}/search`, 'POST', data)
}

function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

function saveItem(data) {
    return utilHelper.doRequest(`${relativeUrl}`, 'POST', data);
}

function updateItem(id, data) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'PUT', data);
}

function deleteItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'DELETE')
}